import React from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { useClientHeader } from './ClientHeaderContext';
import FilterMonthYearPicker from '../../../Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker';
import BiMonthlyPeriodModal from '../../Modals/BiMonthlyPeriodModal';
import Styles from './HeaderToolbar.module.scss';
import '../../ClientDetails.css';
const HeaderActions = React.memo(function HeaderActions() {
    // Get everything from context
    const {
        t, userTypeContext, permissionsState, direction,
        setShowDownloadModal, setShowImportModal,
        isRange, handleRangeChange, isBiMonthly, setShowBiMonth, showBiMonth,
        date, startDate, endDate, biStartDate, biEndDate,
        handleDateChangeNew, handleStartDateChangeNew, handleEndDateChangeNew, handleBiMonthDate,
        isClosedReportingMonth, setActionType, setIsModalVisible, Constants,
        importIconSvg, dayjs,
        formatDateToYearMonth,
        // Advanced
        isAdvancedBiMonthly,
        advancedDate, setAdvancedDate,
        advancedStartDate, setAdvancedStartDate,
        advancedEndDate, setAdvancedEndDate,
        advancedBiStartDate, setAdvancedBiStartDate,
        advancedBiEndDate, setAdvancedBiEndDate,
        handleAdvancedDateChangeNew,
        handleAdvancedStartDateChangeNew,
        handleAdvancedEndDateChangeNew,
        handleAdvancedBiMonthDate,
        handleAdvancedRangeChange
    } = useClientHeader();

    return (
        <>
            {/* Range Switch */}

              <label className={`${Styles.switchRow} ${Styles[direction] || ''}`} dir={direction}>
                <span>{t("DateRange")}</span>
                <input
                  type="checkbox"
                  checked={isRange}
                  onChange={handleRangeChange}
                />
                <span className={Styles.switchTrack} aria-hidden="true" />
              </label>

                {isAdvancedBiMonthly !== isBiMonthly ? (
                    <></>
                ) : (
                    isRange ? (
                        <div className={Styles.dateSelectRange}>
                            {/* Start Date Picker */}
                            <div className={Styles.dateSelect}>
                                <FilterMonthYearPicker
                                    year={startDate}
                                    month={startDate}
                                    onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                    onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                    labelYear={t("StartYear")}
                                    labelMonth={t("StartMonth")}
                                    direction={direction}
                                />
                            </div>
                            {/* Vertical Divider */}
                            <div className={Styles.rangeDivider} />
                            {/* End Date Picker */}
                            <div className={Styles.dateSelect}>
                                <FilterMonthYearPicker
                                    year={endDate}
                                    month={endDate}
                                    onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                    onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                    labelYear={t("EndYear")}
                                    labelMonth={t("EndMonth")}
                                    direction={direction}
                                />
                            </div>
                        </div>
                    ) : isBiMonthly ? (
                        <>
                        <button
                            type="button"
                            className={Styles.periodSelect}
                            onClick={() => setShowBiMonth(true)}
                        >
                            <CalendarTodayOutlinedIcon />
                            <span className={Styles.periodSelectValue}>
                                <span>{formatDateToYearMonth(biStartDate.toISOString())}</span>
                                <span> - </span>
                                <span>{formatDateToYearMonth(biEndDate.toISOString())}</span>
                            </span>
                        </button>
                        <BiMonthlyPeriodModal
                            visible={showBiMonth}
                            onClose={() => setShowBiMonth(false)}
                            date={biStartDate}
                            t={t}
                            onDateChange={(startDate, endDate) => handleBiMonthDate(startDate, endDate)}
                        />
                    </>               
                     ) : (
                        <div className={Styles.dateSelect}>
                            <FilterMonthYearPicker
                                year={date}
                                month={date}
                                onYearChange={(newYear) => handleDateChangeNew(newYear, 'year')}
                                onMonthChange={(newMonth) => handleDateChangeNew(newMonth, 'month')}
                                labelYear={t("Year")}
                                labelMonth={t("Month")}
                                direction={direction}
                            />
                        </div>
                    )
                )}


            {!isRange && (
                <button
                    type="button"
                    className={`${Styles.btn} ${isClosedReportingMonth ? Styles.btnDangerOutline : Styles.btnPurple}`}
                    onClick={() => {
                        if (!isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)) {
                            setActionType(isClosedReportingMonth ? 'openMonth' : 'closeMonth');
                            setIsModalVisible(true);
                        }
                    }}
                    disabled={isClosedReportingMonth && userTypeContext?.toString() === Constants.UserType.Client && permissionsState.Premium}
                    dir={direction}
                >
                    {isClosedReportingMonth ? <LockOpenIcon /> : <LockIcon />}
                    <span>{isClosedReportingMonth ? t("OpenMonthReport") : t("CloseMonthReport")}</span>
                </button>
            )}
            {/* Export/Import Buttons */}
            <div className={`${Styles.actionsCluster} ${direction}`}>
                <button
                    type="button"
                    className={`${Styles.btn} ${Styles.btnOutlineBlue}`}
                    onClick={() => setShowDownloadModal(true)}
                    dir={direction}
                >
                    <FileDownloadIcon />
                    <span>{t("Export Files")}</span>
                </button>
                <button
                    type="button"
                    className={`${Styles.btn} ${Styles.btnOrange}`}
                    onClick={() => setShowImportModal(true)}
                    dir={direction}
                >
                    <FileUploadIcon />
                    <span>{t("ImportFiles")}</span>
                </button>
            </div>
        </>
    );
});

export default HeaderActions;


// import React from 'react';
// import { Button, FormControlLabel, Switch } from '@mui/material';
// import { useClientHeader } from './ClientHeaderContext';
// import CustomMonthYearIndividualDatePicker from '../../../Widgets/CustomDates/CustomMonthYearIndividualDatePicker/CustomMonthYearIndividualDatePicker';
// import BiMonthlyPeriodModal from '../../Modals/BiMonthlyPeriodModal';
// import '../../ClientDetails.css';
// const HeaderActions = React.memo(function HeaderActions() {
//     // Get everything from context
//     const {
//         t, userTypeContext, permissionsState, direction,
//         setShowDownloadModal, setShowImportModal,
//         isRange, handleRangeChange, isBiMonthly, setShowBiMonth, showBiMonth,
//         date, startDate, endDate, biStartDate, biEndDate,
//         handleDateChangeNew, handleStartDateChangeNew, handleEndDateChangeNew, handleBiMonthDate,
//         isClosedReportingMonth, setActionType, setIsModalVisible, Constants,
//         importIconSvg, dayjs,
//         formatDateToYearMonth,
//         // Advanced
//         isAdvancedBiMonthly,
//         advancedDate, setAdvancedDate,
//         advancedStartDate, setAdvancedStartDate,
//         advancedEndDate, setAdvancedEndDate,
//         advancedBiStartDate, setAdvancedBiStartDate,
//         advancedBiEndDate, setAdvancedBiEndDate,
//         handleAdvancedDateChangeNew,
//         handleAdvancedStartDateChangeNew,
//         handleAdvancedEndDateChangeNew,
//         handleAdvancedBiMonthDate,
//         handleAdvancedRangeChange
//     } = useClientHeader();

//     // Defensive fallback for context fields (optional, but good style)
//     const userTypeStr = userTypeContext?.toString() || '';
//     const isPremium = permissionsState?.Premium || false;



//     return (
//         <>
//             {/* Export/Import Buttons */}
//             {(userTypeStr !== Constants?.UserType?.Client || isPremium) && (
//                 <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', marginRight: 'auto' }} className={direction}>
//                     <Button
//                         variant="contained"
//                         startIcon={
//                             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                                 <path d="M4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
//                                 <path d="M12 14V4M12 4L15 7M12 4L9 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                             </svg>
//                         }
//                         onClick={() => setShowDownloadModal(true)}
//                         sx={{
//                             backgroundColor: '#1976D2',
//                             color: '#fff',
//                             borderRadius: '8px',
//                             padding: '10px 20px',
//                             boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
//                             '&:hover': {
//                                 backgroundColor: '#1565C0',
//                             },
//                         }}
//                     >
//                         {t("Export Files")}
//                     </Button>
//                     <Button
//                         variant="contained"
//                         startIcon={
//                             <img
//                                 src={importIconSvg}
//                                 alt="Import Icon"
//                                 width="24"
//                                 height="24"
//                                 style={{ filter: 'invert(100%) brightness(200%)' }}
//                             />
//                         }
//                         onClick={() => setShowImportModal(true)}
//                         sx={{
//                             backgroundColor: 'rgba(249, 170, 42)',
//                             color: '#fff',
//                             borderRadius: '8px',
//                             padding: '10px 20px',
//                             boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
//                             '&:hover': {
//                                 backgroundColor: 'rgba(249, 170, 42)',
//                             },
//                         }}
//                     >
//                         {t("ImportFiles")}
//                     </Button>
//                 </div>
//             )}

//             {/* Range Switch */}

//             <FormControlLabel
//                 control={
//                     <Switch
//                         className="custom-input-box-sizing-toggle"
//                         color="primary"
//                         checked={isRange}
//                         onChange={handleRangeChange}
//                     />
//                 }
//                 label={t("DateRange")}
//                 labelPlacement="bottom"
//             />
//             {/* Main Date Pickers */}
//             {isAdvancedBiMonthly !== isBiMonthly ? (
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
//                     <div style={{ fontWeight: 600, marginBottom: 4, marginTop: '5px' }}>{t('VatReportDates')}</div>
//                     {isRange ? (
//                         <div style={{ display: 'flex', flexDirection: 'column'}}>
//                             {/* Start Date Picker */}
//                             <CustomMonthYearIndividualDatePicker
//                                 year={startDate}
//                                 month={startDate}
//                                 onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
//                                 onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
//                                 labelYear={t("StartYear")}
//                                 labelMonth={t("StartMonth")}
//                                 height="48px"
//                                 widthOuter='270px'
//                                 widthInner='120px'
//                                 flip={true}
//                             />
//                             {/* End Date Picker */}
//                             <CustomMonthYearIndividualDatePicker
//                                 year={endDate}
//                                 month={endDate}
//                                 onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
//                                 onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
//                                 labelYear={t("EndYear")}
//                                 labelMonth={t("EndMonth")}
//                                 height="48px"
//                                 widthOuter='270px'
//                                 widthInner='120px'
//                                 flip={true}
//                             />

//                         </div>
//                     ) : isBiMonthly ? (
//                         <>
//                             <div
//                                 className="bidate-custom-input"
//                                 style={{ backgroundColor: '#F5F5F6', borderRadius: '8px', display: 'flex', flexDirection: 'row' }}
//                                 onClick={() => setShowBiMonth(true)}
//                             >
//                                 <p>{formatDateToYearMonth(biStartDate.toISOString())}</p>
//                                 <p> - </p>
//                                 <p>{formatDateToYearMonth(biEndDate.toISOString())}</p>
//                             </div>
//                             <BiMonthlyPeriodModal
//                                 visible={showBiMonth}
//                                 onClose={() => setShowBiMonth(false)}
//                                 date={date}
//                                 t={t}
//                                 onDateChange={(startDate, endDate) => handleBiMonthDate(startDate, endDate)}
//                             />
//                         </>
//                     ) : (
//                         <CustomMonthYearIndividualDatePicker
//                             year={date}
//                             month={date}
//                             onYearChange={(newYear) => handleDateChangeNew(newYear, 'year')}
//                             onMonthChange={(newMonth) => handleDateChangeNew(newMonth, 'month')}
//                             labelYear={t("Year")}
//                             labelMonth={t("Month")}
//                             height="48px"
//                             widthOuter='270px'
//                             widthInner='120px'
//                             flip={true}
//                         />
//                     )}
//                 </div>
//             ) : (
//                 isRange ? (
//                     <div style={{ display: 'flex', columnGap: '20px' }}>
//                         {/* End Date Picker */}
//                         <CustomMonthYearIndividualDatePicker
//                             year={endDate}
//                             month={endDate}
//                             onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
//                             onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
//                             labelYear={t("EndYear")}
//                             labelMonth={t("EndMonth")}
//                             height="48px"
//                             widthOuter='270px'
//                             widthInner='120px'
//                             flip={true}
//                         />
//                         {/* Vertical Divider */}
//                         <div
//                             style={{
//                                 borderLeft: '1px solid #ccc',
//                                 height: '48px',
//                             }}
//                         ></div>
//                         <CustomMonthYearIndividualDatePicker
//                             year={startDate}
//                             month={startDate}
//                             onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
//                             onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
//                             labelYear={t("StartYear")}
//                             labelMonth={t("StartMonth")}
//                             height="48px"
//                             widthOuter='270px'
//                             widthInner='120px'
//                             flip={true}
//                         />
//                     </div>
//                 ) : isBiMonthly ? (
//                     <>
//                         <div
//                             className="bidate-custom-input"
//                             style={{ backgroundColor: '#F5F5F6', borderRadius: '8px', display: 'flex', flexDirection: 'row' }}
//                             onClick={() => setShowBiMonth(true)}
//                         >
//                             <p>{formatDateToYearMonth(biStartDate.toISOString())}</p>
//                             <p> - </p>
//                             <p>{formatDateToYearMonth(biEndDate.toISOString())}</p>
//                         </div>
//                         <BiMonthlyPeriodModal
//                             visible={showBiMonth}
//                             onClose={() => setShowBiMonth(false)}
//                             date={date}
//                             t={t}
//                             onDateChange={(startDate, endDate) => handleBiMonthDate(startDate, endDate)}
//                         />
//                     </>
//                 ) : (
//                     <CustomMonthYearIndividualDatePicker
//                         year={date}
//                         month={date}
//                         onYearChange={(newYear) => handleDateChangeNew(newYear, 'year')}
//                         onMonthChange={(newMonth) => handleDateChangeNew(newMonth, 'month')}
//                         labelYear={t("Year")}
//                         labelMonth={t("Month")}
//                         height="48px"
//                         widthOuter='270px'
//                         widthInner='120px'
//                         flip={true}
//                     />
//                 )
//             )}

//             {/* Advanced Date Pickers */}
//             {isAdvancedBiMonthly !== isBiMonthly && (
//                 <div style={{ marginTop: 16 }}>
//                     <div style={{ fontWeight: 600, marginBottom: 4 }}>{t('AdvancedReportingDates')}</div>
//                     {isRange ? (
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
//                             <CustomMonthYearIndividualDatePicker
//                                 year={advancedStartDate}
//                                 month={advancedStartDate}
//                                 onYearChange={(newYear) => handleAdvancedStartDateChangeNew(newYear, 'year')}
//                                 onMonthChange={(newMonth) => handleAdvancedStartDateChangeNew(newMonth, 'month')}
//                                 labelYear={t("AdvancedStartYear")}
//                                 labelMonth={t("AdvancedStartMonth")}
//                                 height="48px"
//                                 widthOuter='270px'
//                                 widthInner='120px'
//                                 flip={true}
//                             />
//                             <CustomMonthYearIndividualDatePicker
//                                 year={advancedEndDate}
//                                 month={advancedEndDate}
//                                 onYearChange={(newYear) => handleAdvancedEndDateChangeNew(newYear, 'year')}
//                                 onMonthChange={(newMonth) => handleAdvancedEndDateChangeNew(newMonth, 'month')}
//                                 labelYear={t("AdvancedEndYear")}
//                                 labelMonth={t("AdvancedEndMonth")}
//                                 height="48px"
//                                 widthOuter='270px'
//                                 widthInner='120px'
//                                 flip={true}
//                             />
                           
//                         </div>
//                     ) : isAdvancedBiMonthly ? (
//                         <>
//                             <div
//                                 className="bidate-custom-input"
//                                 style={{ backgroundColor: '#F5F5F6', borderRadius: '8px', display: 'flex', flexDirection: 'row' }}
//                                 onClick={() => setShowBiMonth(true)}
//                             >
//                                 <p>{formatDateToYearMonth(advancedBiStartDate.toISOString())}</p>
//                                 <p> - </p>
//                                 <p>{formatDateToYearMonth(advancedBiEndDate.toISOString())}</p>
//                             </div>
//                             <BiMonthlyPeriodModal
//                                 visible={showBiMonth}
//                                 onClose={() => setShowBiMonth(false)}
//                                 date={advancedDate}
//                                 t={t}
//                                 onDateChange={(startDate, endDate) => handleAdvancedBiMonthDate(startDate, endDate)}
//                             />
//                         </>
//                     ) : (
//                         <CustomMonthYearIndividualDatePicker
//                             year={advancedDate}
//                             month={advancedDate}
//                             onYearChange={(newYear) => handleAdvancedDateChangeNew(newYear, 'year')}
//                             onMonthChange={(newMonth) => handleAdvancedDateChangeNew(newMonth, 'month')}
//                             labelYear={t("AdvancedMonthYear")}
//                             labelMonth={t("AdvancedMonth")}
//                             height="48px"
//                             widthOuter='270px'
//                             widthInner='120px'
//                             flip={true}
//                         />
//                     )}
//                 </div>
//             )}

//             {!isRange && (
//                 <Button
//                     variant="contained"
//                     onClick={() => {
//                         if (!isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)) {
//                             setActionType(isClosedReportingMonth ? 'openMonth' : 'closeMonth');
//                             setIsModalVisible(true);
//                         }
//                     }}
//                     disabled={isClosedReportingMonth && userTypeContext?.toString() === Constants.UserType.Client && permissionsState.Premium}
//                     sx={{
//                         backgroundColor: isClosedReportingMonth ? '#FF3D00' : '#304FFF', // Red when open, blue when closed
//                         color: '#fff',
//                         '&:hover': {
//                             backgroundColor: isClosedReportingMonth ? '#D32F2F' : '#1E40FF', // Slightly darker on hover
//                         },
//                         borderRadius: '8px',
//                         pointerEvents: !isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)
//                             ? 'auto'
//                             : 'none',
//                         opacity: !isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)
//                             ? 1
//                             : 0.6,
//                     }}
//                 >
//                     {isClosedReportingMonth ? t("OpenMonthReport") : t("CloseMonthReport")}

//                 </Button>

//             )}
//         </>
//     );
// });

// export default HeaderActions;